import type { BlogPost } from '../types';

const post: BlogPost = {
    slug: 'welcome',
    title: 'Welcome to My Software Engineering Blog',
    date: '2025-12-03',
    description: 'Introduction to this blog and what to expect from future posts.',
    tags: ['meta', 'introduction'],
    content: `Welcome to my software engineering blog! This is a space where I'll be sharing insights, experiences, and lessons learned from various software engineering topics.

I plan to cover a wide range of subjects including:

- Software architecture and design patterns
- Best practices in software development
- Modern web technologies
- DevOps and CI/CD
- Performance optimization
- And much more!

Stay tuned for upcoming posts!`,
};

export default post;
